import {
	Card,
	CardContent,
	CardMedia,
	Chip,
	IconButton,
	Typography,
	Menu,
	MenuItem,
	Dialog,
	DialogTitle,
	DialogContent,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid2';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { deleteProduct } from '../../../services/api/ProductAPI';
import ViewProducts from './ViewPorducts';
import { StyledCrossIconButton } from '../../../components/component/ThemeComponent';
import userContext from '../../../configs/context/context';
const BASE_URL = process.env.REACT_APP_BASE_IMAGE_URL;

interface wholesale {
	type: 'text' | 'image';
	label: string;
	required: boolean;
}
interface buldDiscount {
	minQuantity: number;
	maxQuantity: number;
	discountPercentage: number;
}

interface SizesVariant {
	_id?: string;
	size: string;
}

export interface ColorVariant {
	colorName: string;
	colorCode: string;
	price: number;
	strickoutPrice: number;
	sizes: SizesVariant[];
	colorImage: string[];
	_id?: string;
}
interface Product {
	_id: string;
	name: string;
	category: string;
	description: string;
	price: number;
	quantity: string;
	bestSelling: boolean;
	trending: boolean;
	image: string[];
	productImage: string[];
	weight: string;
	weightUnit: string;
	isInquiry: boolean;
	isBulkDiscount: boolean;
	isCustomized: boolean;
	slug?: string;
	isWholesale: boolean;
	wholesaleFields: wholesale[];
	buldDiscountsData: buldDiscount[];
	wholesaleMinQuantity: number;
	productId: string;
	isStickoutPrice: boolean;
	isColorVariantAvailable: boolean;
	strickoutPrice: number;
	colorVariants: ColorVariant[];
	createdByModel?: any;
}
interface ProductCardProps {
	product: Product;
	onClick: () => void;
	handleEditProduct: (product: ProductCardProps['product']) => void;
	fetchData: () => Promise<void>;
}

const ProductCard: React.FC<ProductCardProps> = ({
	product,
	onClick,
	handleEditProduct,
	fetchData,
}) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const [isDialogOpen, setIsDialogOpen] = useState(false);
	const { Vendorme } = useContext<any>(userContext);
	const permmission = Vendorme?.permissions?.products;
	const slug = localStorage.getItem('slug');
	const location = window.location.pathname.split('/');
	const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
		event.stopPropagation();
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleEdit = (product: Product) => {
		if (!product.category || product.category.trim() === '') {
			toast.error('Invalid category value. Please select a valid category.');
			return;
		}
		handleEditProduct(product);
		handleMenuClose();
	};

	const handleDelete = async () => {
		console.log('delete funtion invoked');
		const confirmToastId = toast(
			<div>
				<p>Are you sure you want to delete this product?</p>
				<button
					onClick={async () => {
						toast.dismiss(confirmToastId);
						try {
							const response = await deleteProduct(product._id);
							if (response.success) {
								toast.success(response.data.message);
								fetchData();
							} else {
								toast.error(response.data.message);
							}
						} catch (e) {
							console.log(e);
						} finally {
							handleMenuClose();
						}
					}}
					style={{
						marginRight: '10px',
						padding: '5px 10px',
						background: 'red',
						color: 'white',
						border: 'none',
						cursor: 'pointer',
					}}
					type="button"
				>
					Yes
				</button>
				<button
					onClick={() => toast.dismiss(confirmToastId)}
					style={{
						padding: '5px 10px',
						background: 'gray',
						color: 'white',
						border: 'none',
						cursor: 'pointer',
					}}
					type="button"
				>
					No
				</button>
			</div>,
			{ autoClose: false, closeOnClick: false }
		);
	};

	const handleViewProduct = () => {
		setIsDialogOpen(true);
	};

	const handleCloseDialog = () => {
		setIsDialogOpen(false);
	};

	return (
		<>
			<Card sx={{ maxWidth: 250, m: 1 }} onClick={onClick} style={{ cursor: 'pointer' }}>
				<div style={{ position: 'relative' }}>
					<CardMedia
						component="img"
						height="140"
						image={
							product.isColorVariantAvailable && product.colorVariants.length > 0
								? product.colorVariants[0].colorImage.length > 0
									? `${BASE_URL}${product.colorVariants[0].colorImage[0]}`
									: '/assets/image-not-found.webp'
								: product?.image?.length > 0
									? `${BASE_URL}${product.image[0]}`
									: '/assets/image-not-found.webp'
						}
						alt={product?.name}
						onClick={handleViewProduct}
					/>
					{product?.createdByModel === 'Vendor' &&
					location?.includes(slug as string) &&
					(permmission?.edit || permmission?.delete) ? (
						<IconButton
							aria-label="more"
							aria-controls="long-menu"
							aria-haspopup="true"
							onClick={handleMenuClick}
							style={{ position: 'absolute', top: 0, right: 0 }}
						>
							{anchorEl ? <MoreVertIcon /> : <MoreHorizIcon />}
						</IconButton>
					) : (
						!location.includes(slug as string) && (
							<IconButton
								aria-label="more"
								aria-controls="long-menu"
								aria-haspopup="true"
								onClick={handleMenuClick}
								style={{ position: 'absolute', top: 0, right: 0 }}
							>
								{anchorEl ? <MoreVertIcon /> : <MoreHorizIcon />}
							</IconButton>
						)
					)}
					{!product.isInquiry && (
						<Typography
							variant="body2"
							color="text.secondary"
							style={{
								fontFamily: 'Poppins',
								fontSize: '12px',
								color: '#0C8040',
								position: 'absolute',
								bottom: -35,
								right: 8,
							}}
						>
							<Inventory2OutlinedIcon style={{ fontSize: '12px' }} /> Stock:{' '}
							<span>{product?.quantity}</span>
						</Typography>
					)}
				</div>
				<CardContent>
					<Grid container spacing={1}>
						<Grid size={{ xs: 12 }}>
							<Chip
								label={product?.category}
								size="small"
								color="success"
								variant="outlined"
								sx={{ mb: 1, fontFamily: 'Poppins' }}
							/>
						</Grid>
						<Grid size={{ xs: 12 }}>
							<Typography
								variant="h6"
								fontFamily={'Poppins'}
								style={{
									fontSize: '14px',
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
								}}
							>
								{product?.name}
							</Typography>
						</Grid>
						{!product.isInquiry && (
							<>
								{' '}
								<Grid size={{ xs: 10 }}>
									<Typography
										variant="body1"
										color="text.secondary"
										style={{
											fontFamily: 'Poppins',
											fontSize: '13px',
											fontWeight: '500',
											color: 'black',
										}}
									>
										₹{' '}
										{product.isColorVariantAvailable &&
										product.colorVariants.length > 0
											? product.colorVariants[0].price
												? product.colorVariants[0].price
												: 0
											: product?.price?.toFixed(2)}
									</Typography>
								</Grid>
							</>
						)}
					</Grid>
				</CardContent>
				{product.isInquiry && (
					<Typography
						sx={{
							margin: 'auto',
							textAlign: 'center',
							backgroundColor: '#0C8040',
							color: 'white',
							padding: '7px',
						}}
					>
						Enquiry Product
					</Typography>
				)}
			</Card>
			{product?.createdByModel === 'Vendor' &&
			location?.includes(slug as string) &&
			(permmission?.edit || permmission?.delete) ? (
				<Menu
					id="long-menu"
					anchorEl={anchorEl}
					open={open}
					onClose={handleMenuClose}
					slotProps={{
						paper: {
							style: {
								maxHeight: 48 * 4.5,
								width: '20ch',
								fontFamily: 'Poppins',
								paddingBottom: '0px',
								paddingTop: '0px',
							},
						},
					}}
					className="product-card-menu"
				>
					{permmission?.edit && (
						<MenuItem
							onClick={() => handleEdit(product)}
							sx={{ fontFamily: 'Poppins', '&:hover': { color: '#fff' } }}
						>
							Edit
						</MenuItem>
					)}
					{permmission?.delete && (
						<MenuItem
							onClick={handleDelete}
							sx={{ fontFamily: 'Poppins', '&:hover': { color: '#fff' } }}
						>
							Delete
						</MenuItem>
					)}
				</Menu>
			) : (
				!location.includes(slug as string) && (
					<Menu
						id="long-menu"
						anchorEl={anchorEl}
						open={open}
						onClose={handleMenuClose}
						slotProps={{
							paper: {
								style: {
									maxHeight: 48 * 4.5,
									width: '20ch',
									fontFamily: 'Poppins',
									paddingBottom: '0px',
									paddingTop: '0px',
								},
							},
						}}
						className="product-card-menu"
					>
						<MenuItem
							onClick={() => handleEdit(product)}
							sx={{ fontFamily: 'Poppins', '&:hover': { color: '#fff' } }}
						>
							Edit
						</MenuItem>
						<MenuItem
							onClick={handleDelete}
							sx={{ fontFamily: 'Poppins', '&:hover': { color: '#fff' } }}
						>
							Delete
						</MenuItem>
					</Menu>
				)
			)}
			<Dialog open={isDialogOpen} onClose={handleCloseDialog} maxWidth="md" fullWidth>
				<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between' }}>
					<span>View Products</span>
					<StyledCrossIconButton onClick={handleCloseDialog}>
						<CloseIcon />
					</StyledCrossIconButton>
				</DialogTitle>
				<DialogContent sx={{ paddingTop: '10px !important' }}>
					<ViewProducts product={product} />
				</DialogContent>
			</Dialog>
		</>
	);
};

ProductCard.propTypes = {
	product: PropTypes.shape({
		_id: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
		price: PropTypes.number.isRequired,
		quantity: PropTypes.string.isRequired,
		bestSelling: PropTypes.bool.isRequired,
		trending: PropTypes.bool.isRequired,
		productImage: PropTypes.arrayOf(PropTypes.string).isRequired,
		weight: PropTypes.string.isRequired,
		weightUnit: PropTypes.string.isRequired,
		category: PropTypes.string.isRequired,
		description: PropTypes.string.isRequired,
		isInquiry: PropTypes.bool.isRequired,
		isBulkDiscount: PropTypes.bool.isRequired,
		image: PropTypes.arrayOf(PropTypes.string).isRequired,
		isCustomized: PropTypes.bool.isRequired,
		slug: PropTypes.string,
		isWholesale: PropTypes.bool.isRequired,
		isColorVariantAvailable: PropTypes.bool.isRequired,
		createdByModel: PropTypes.any,
		colorVariants: PropTypes.arrayOf(
			PropTypes.shape({
				colorName: PropTypes.string.isRequired,
				colorCode: PropTypes.string.isRequired,
				price: PropTypes.number.isRequired,
				strickoutPrice: PropTypes.number.isRequired,
				colorImage: PropTypes.arrayOf(PropTypes.string).isRequired,
				sizes: PropTypes.arrayOf(
					PropTypes.shape({
						size: PropTypes.string.isRequired,
						_id: PropTypes.string,
					})
				).isRequired,
				_id: PropTypes.string,
			})
		).isRequired,
		wholesaleFields: PropTypes.arrayOf(
			PropTypes.shape({
				type: PropTypes.oneOf(['text', 'image']).isRequired,
				label: PropTypes.string.isRequired,
				required: PropTypes.bool.isRequired,
			})
		).isRequired,
		buldDiscountsData: PropTypes.arrayOf(
			PropTypes.shape({
				minQuantity: PropTypes.number.isRequired,
				maxQuantity: PropTypes.number.isRequired,
				discountPercentage: PropTypes.number.isRequired,
			})
		).isRequired,
		wholesaleMinQuantity: PropTypes.number.isRequired,
		productId: PropTypes.string.isRequired,
		isStickoutPrice: PropTypes.bool.isRequired,
		strickoutPrice: PropTypes.number.isRequired,
	}).isRequired,
	onClick: PropTypes.func.isRequired,
	handleEditProduct: PropTypes.func.isRequired,
	fetchData: PropTypes.func.isRequired,
};

export default ProductCard;
